import React from 'react';
import PropTypes from 'prop-types';
import NotificationSystem from 'react-notification-system';
import { muiThemeLuma } from 'themes';

// not using withStyles since notification component is old and only accepts inline
const styles = {
  Title: {
    DefaultStyle: {
      fontSize: 14,
    },
    info: {
      color: muiThemeLuma.palette.text.primary, // Changed to value due to since no access to theme
    },
  },
  NotificationItem: {
    DefaultStyle: {
      fontSize: 12,
    },
    info: {
      borderTop: `4px solid ${muiThemeLuma.palette.text.primary}`,
      backgroundColor: 'white',
      boxShadow: '#E0E0E0 0px 1px 6px, #E0E0E0 0px 1px 4px',
    },
  },
};

class Notifications extends React.PureComponent {
  constructor(props) {
    super(props);

    this.showNotification = this.showNotification.bind(this);
  }

  componentDidMount() {
    const { notification } = this.props;

    if (notification) this.showNotification(notification);
  }

  componentWillUpdate(nextProps) {
    const { notification } = nextProps;

    if (notification) this.showNotification(notification);
  }

  showNotification(notification) {
    const { onShow } = this.props;

    this.refNotificationSystem.addNotification({
      title: 'Notification',
      message: notification.text || notification,
      level: 'info',
      position: 'bl',
    });

    onShow();
  }

  render() {
    return (
      <NotificationSystem
        ref={(el) => {
          this.refNotificationSystem = el;
        }}
        style={styles}
        autoDismiss={5}
      />
    );
  }
}

Notifications.propTypes = {
  notification: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.bool]),
  onShow: PropTypes.func,
};

export default Notifications;
